require('./bootstrap');

// vendor libraries
require('jquery.cookie');
require('jquery-modal');
require('./vendor_rewrites/tiltjs/tilt.jquery');
require('devbridge-autocomplete');
require('lazysizes');
window.wow = require('wowjs');
window.Domurl = require('domurl');
new window.wow.WOW().init();
window.Swiper = require('swiper/bundle').Swiper;
window.FastImageSequence = require('@mediamonks/fast-image-sequence').FastImageSequence;

// custom
require('./custom/lib/main');
require('./custom/lib/auth');
require('./custom/lib/language-select');
require('./custom/lib/preload-images');
require('./custom/lib/form-error-handler');
require('./custom/lib/cookie2');
require('./custom/lib/faq');
require('./custom/jivosite/jivosite');
require('./custom/page-init/input-handler');
require('./custom/header/display-logic');
